export default __webpack_public_path__ + "static/media/joytcp.8baf233e.png";